import {ref} from '@vue/composition-api';

const useShop = (initialVal) => {
    
    const shop = ref(initialVal)

    const setShop = val => {
        shop.value = val
    }

    return {
        shop, 
        setShop
    }
}

export default useShop